import ApiService from '@/core/services/api.service'
import { makeToastSuccess, handleError } from '@/utils/common'
import { getCurrentDate } from '@/utils/date'

export const getWarrantyReceptions = async (params) => {
  try {
    const response = await ApiService.query('v1/warranties/receptions', { params })
    return response.data.data
  } catch (err) {
    handleError(err)
    return { dataset: [], totalRow: 0, totalPage: 1 }
  }
}

export const getWarranties = async (params) => {
  try {
    const response = await ApiService.query('v1/warranties', { params })
    return response.data.data
  } catch (err) {
    handleError(err)
    return { dataset: [], totalRow: 0, totalPage: 1 }
  }
}

export const getWarrantyReportDetail = async (params) => {
  try {
    const response = await ApiService.query('v1/warranty-reports/detail', { params })
    return response.data.data || { dataset: [], totalRow: 0, totalPage: 1 }
  } catch (err) {
    handleError(err)
    return { dataset: [], totalRow: 0, totalPage: 1 }
  }
}

/** Báo cáo tổng hợp: danh sách phiếu (có phân trang) */
export const getWarrantyReports = async (params) => {
  try {
    const response = await ApiService.query('v1/warranty-reports', { params })
    return response.data.data || { dataset: [], totalRow: 0, totalPage: 1 }
  } catch (err) {
    handleError(err)
    return { dataset: [], totalRow: 0, totalPage: 1 }
  }
}

/** Báo cáo tổng hợp: KPI (totalRevenue, warrantyCount, unpaidCount) */
export const getWarrantyReportsSummary = async (params) => {
  try {
    const response = await ApiService.query('v1/warranty-reports/summary', { params })
    return response.data.data || { totalRevenue: 0, warrantyCount: 0, unpaidCount: 0 }
  } catch (err) {
    handleError(err)
    return { totalRevenue: 0, warrantyCount: 0, unpaidCount: 0 }
  }
}

export const getWarrantyReportsByEmployee = async (params) => {
  try {
    const response = await ApiService.query('v1/warranty-reports/by-employee', { params })
    return response.data.data || { dataset: [], totalRow: 0, totalPage: 1 }
  } catch (err) {
    handleError(err)
    return { dataset: [], totalRow: 0, totalPage: 1 }
  }
}

export const getWarrantyById = async (id) => {
  try {
    const response = await ApiService.get(`v1/warranties/${id}`)
    return response.data.data
  } catch (err) {
    handleError(err)
    return null
  }
}

// Reception APIs
export const findOneReception = async (id) => {
  try {
    const response = await ApiService.get(`v1/warranties/receptions/${id}`)
    return response.data.data
  } catch (err) {
    handleError(err)
    return null
  }
}

export const createReception = async (payload) => {
  try {
    const response = await ApiService.post('v1/warranties/receptions', payload)
    const message = response.data?.message
    makeToastSuccess(message)
    return response.data.data
  } catch (err) {
    handleError(err)
    throw err
  }
}

export const createWarrantyRejection = async (payload) => {
  try {
    const response = await ApiService.post('v1/warranties/receptions/rejection', payload)
    const message = response.data?.message
    makeToastSuccess(message)
    return response.data.data
  } catch (err) {
    handleError(err)
    throw err
  }
}

export const getTradeInInfo = async (id) => {
  try {
    const response = await ApiService.get(`v1/trade-ins/${id}`)
    return response.data.data
  } catch (err) {
    handleError(err)
    return null
  }
}

export const updateReception = async (id, payload) => {
  try {
    const response = await ApiService.put(`v1/warranties/receptions/${id}`, payload)
    const { message } = response.data
    makeToastSuccess(message)
    return response.data.data
  } catch (err) {
    handleError(err)
    throw err
  }
}

// Dispatch APIs
export const findOneDispatch = async (id) => {
  try {
    const response = await ApiService.get(`v1/warranties/${id}`)
    return response.data.data
  } catch (err) {
    handleError(err)
    throw err
  }
}

export const updateDispatch = async (id, payload) => {
  try {
    const response = await ApiService.put(`v1/warranties/${id}`, payload)
    const { message } = response.data
    makeToastSuccess(message)
    return response.data.data
  } catch (err) {
    handleError(err)
    throw err
  }
}

export const getTechnicalErrorsByGroup = async (errorGroupId) => {
  try {
    const response = await ApiService.query(`v1/warranty/error-groups/${errorGroupId}/technical-errors`)
    return response.data.data
  } catch (err) {
    handleError(err)
    return []
  }
}

export const bulkUpdateWarrantyStatus = async (payload) => {
  try {
    const response = await ApiService.patch('v1/warranties/status', payload)
    return response.data.data || []
  } catch (err) {
    handleError(err)
    throw err
  }
}

export const changeWarrantyStore = async (warrantyId, storeId) => {
  try {
    const response = await ApiService.patch('v1/warranties/change-store', {
      warrantyId,
      storeId,
    })
    const message = response.data?.message
    if (message) makeToastSuccess(message)
    return response.data?.data
  } catch (err) {
    handleError(err)
    throw err
  }
}

export const confirmWarrantyTransfer = async (warrantyId) => {
  try {
    const response = await ApiService.patch('v1/warranties/confirm-transfer', {
      warrantyId,
    })
    const message = response.data?.message
    if (message) makeToastSuccess(message)
    return response.data?.data
  } catch (err) {
    handleError(err)
    throw err
  }
}

export const updateWarranty = async (id, payload) => {
  try {
    const response = await ApiService.put(`v1/warranties/receptions/${id}`, payload)
    const { message } = response.data
    makeToastSuccess(message)
    return response.data.data
  } catch (err) {
    handleError(err)
    throw err
  }
}

export const deleteWarrantyReception = async (id) => {
  try {
    if (Array.isArray(id)) {
      const promises = id.map((itemId) => ApiService.delete(`v1/warranties/receptions/${itemId}`))
      await Promise.all(promises)
      makeToastSuccess('Xóa thành công')
      return true
    } else {
      await ApiService.delete(`v1/warranties/receptions/${id}`)
      return true
    }
  } catch (err) {
    handleError(err)
    return false
  }
}

export const getAccompanyingEquipments = async () => {
  try {
    const response = await ApiService.get('v1/warranty/accompanying-equipments/all')
    return response.data.data || []
  } catch (err) {
    handleError(err)
    return []
  }
}

export const getWarrantyServices = async () => {
  try {
    const response = await ApiService.get('v1/warranty/services/select')
    return response.data.data || []
  } catch (err) {
    handleError(err)
    return []
  }
}

export const getSolutions = async (params = {}) => {
  try {
    const response = await ApiService.query('v1/warranty/solutions', {
      params: { isActive: true, limit: 100, ...params },
    })
    return response.data.data?.items || []
  } catch (err) {
    handleError(err)
    return []
  }
}

export const getAllSolutions = async () => {
  try {
    const response = await ApiService.query('v1/warranty/solutions/all')
    return response.data.data || []
  } catch (err) {
    handleError(err)
    return []
  }
}

export const getErrorGroups = async () => {
  try {
    const response = await ApiService.query('v1/warranty/error-groups', {
      params: { isActive: true, limit: 100 },
    })
    return response.data.data?.items || response.data.data || []
  } catch (err) {
    handleError(err)
    return []
  }
}

export const getTechnicalErrors = async (errorGroupId) => {
  try {
    if (!errorGroupId) return []
    const response = await ApiService.get(
      `v1/warranty/error-groups/${errorGroupId}/technical-errors`,
      {
        params: { isActive: true },
      },
    )
    return response.data.data?.items || []
  } catch (err) {
    handleError(err)
    return []
  }
}

export const getErrorSeverities = async () => {
  try {
    const response = await ApiService.query('v1/warranty/error-severities', {
      params: { limit: 1000 },
    })
    return response.data.data?.items || response.data.data || []
  } catch (err) {
    handleError(err)
    return []
  }
}

export const getReplaceProductsByWarrantyId = async (warrantyId) => {
  if (!warrantyId) return []
  try {
    const response = await ApiService.get(`v1/warranties/${warrantyId}/replace-products`)
    return response.data.data || []
  } catch (err) {
    handleError(err)
    return []
  }
}

export const checkWarrantyByImei = async (imeiCode) => {
  if (!imeiCode) return null
  try {
    const response = await ApiService.query('v1/warranties/check', {
      params: { imeiCode },
    })
    return response.data.data || null
  } catch (err) {
    handleError(err)
    return null
  }
}

export const calculateActualCost = async (warrantyId, { warrantyRepairs = [], supportCost = 0 } = {}) => {
  try {
    const response = await ApiService.post(`v1/warranties/${warrantyId}/calculate-cost`, {
      warrantyRepairs,
      supportCost,
    })
    return response.data.data || null
  } catch (err) {
    handleError(err)
    return null
  }
}

export const updateInternalNote = async (warrantyId, internalNote) => {
  try {
    const response = await ApiService.patch(`v1/warranties/${warrantyId}/internal-note`, {
      internalNote,
    })
    const message = response.data?.message
    if (message) makeToastSuccess(message)
    return response.data?.data
  } catch (err) {
    handleError(err)
    throw err
  }
}

const downloadBlob = (data, filename) => {
  const url = window.URL.createObjectURL(new Blob([data]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const exportWarrantyReportExcel = async (params) => {
  try {
    const response = await ApiService.query('/v1/warranty-reports/export', {
      params,
      responseType: 'blob',
    })
    downloadBlob(response.data, `bao_cao_tien_bao_banh_${getCurrentDate('YYYYMMDD_HHmmss')}.xlsx`)
  } catch (err) {
    handleError(err)
  }
}

export const exportWarrantyReportDetailExcel = async (params) => {
  try {
    const response = await ApiService.query('/v1/warranty-reports/detail/export', {
      params,
      responseType: 'blob',
    })
    downloadBlob(response.data, `bao_cao_tong_hop_bao_hanh_${getCurrentDate('YYYYMMDD_HHmmss')}.xlsx`)
  } catch (err) {
    handleError(err)
  }
}

export const exportWarrantyReportByEmployeeExcel = async (params) => {
  try {
    const response = await ApiService.query('/v1/warranty-reports/by-employee/export', {
      params,
      responseType: 'blob',
    })
    downloadBlob(response.data, `bao_cao_bao_hanh_nhan_vien_${getCurrentDate('YYYYMMDD_HHmmss')}.xlsx`)
  } catch (err) {
    handleError(err)
  }
}
